export default {
  welcome: '欢迎',
  home: '首页',
  currentStore: '当前店铺',
  switchStore: '切换到店铺',
  dashboard: 'Dashboard',
  region: '国别',
  today: '今日',
  yesterday: '昨日',
  latest7Days: '最近7日',
  thisMonth: '当月',
  previousMonth: '上月',
  withinThreeMonths: '3月内',
  talking: '对话',
  unreplied: '未回复',
  toProcess: '待处理',
  orderCount: '订单数',
  topProducts: '热门商品',
  // actualSold: '按真实出售',
  orderCount1: '按订单数',
  views: '按点击',
  rejectedCount: '按拒收数',
  buyerCount: '按客户数',
  new: '新订单',
  pendingConfirm: '待确认',
  pendingDispatch: '待发货',
  inDelivery: '派送中',
  inTransit: '运输中',
  completed: '已完成',
  rejected: '已拒收',
  cancelled: '已取消',
  submitted: '提交的',
  inProgress: '履行中',
  success: '完成的',
  listingId: 'Listing ID',
  title: '标题',
  actualSold: '实际售出',
  selectStore: '请选择切换的店铺！',
  switchSuccess: '切换成功！',
  within7Days: '7日内',
  within30Days: '30日内',
  cannot92Days: '不能超过92天',
  rejectedCount1: '拒收数',
  buyerCount1: '买家数',
  views1: '点击数',
  GMV: '销售额',
  currentLockStatus: '当前锁定状态',
  Locked: '已锁定',
  Unlock: '未锁定',
  toRemindPayment: '催付订单',
  toDispatch: '等待发货',
  toProcessAftersale: '售后待处理',
  toProcessCancellation: '订单取消待处理',
  toReplyMessages: '待回复消息',
  toReplyReviews: '待回复评论',
  violatingPolicyProducts: '违规下架商品',
  toConfirmRestockInvitations: '待确认备货邀请',
  toApplyRestockInvitations: '待申请备货邀请',
  toDispatchRestockApplications: '待发货备货箱单',
  doListTitle: '待办事项',
  needToDealWith: '需要你处理的事项',
  announcements: '通知',
  businessOverview: '数据概览',
  more: '查看更多',
  newText: '最新',
  dateRange: '时期范围',
  last7days: '最近7日',
  last14days: '最近14日',
  last30days: '最近30日',
  thisWeek: '本周',
  lastWeek: '上周',
  lastMonth: '上月',
  sortBy: 'Sort by',
  ordersQty: '提交订单销量',
  top5Products: '前5商品',
  sku: 'SKU',
  productName: '商品名称',
  vsPreviousPeriod: '环比上一周期',
  paidOrders: '订单数',
  averagePaidOrderValue: '平均订单金额',
  Visitors: '访客数',
  paidBuyers: '付费买家数',
  paidConversionRate: '付费转化率',
  paidGmvTrend: '销售额走势',
  yourStoreClose: '您的店铺在部分国家站处于歇业状态，在歇业期间不会获得这些国家站的卖家自发货订单：',
  yourStorePossible: '可能由于违规原因',
  yourStorePossible1: '，您的店铺在部分国家市场被锁定，在此期间，您不能新增商品，也不能获得新订单。涉及的国家站有：',
  yourStorePossible2: '如需帮助请联系官方卖家支持团队',
  goToSetting: '去店铺设置',
  paidGmv: '销售额',
  grossRevenue: '销售额',
  paidGmvTip: '买家支付的订单金额',
  grossRevenueTip: '买家已经支付的订单商品金额，未扣除任何折扣',
  visitorsTip: '浏览过店铺中商品页面的独立用户数，同一个用户不会重复计算',
  paidOrdersTip: '买家支付的订单数',
  paidBuyersTip: '支付并购买了您店铺商品的买家数',
  averagePaidTip: '买家支付订单的平均金额',
  paidConversionTip: '店铺访客中转化为付费买家的比例',
  paidOrderQty: '销量',
  remindMeDaily: '每日提醒我',
  toImprovePerformanceMetrics: '待提升绩效指标',
  bestSellingProducts: '商品销售排行',
  mostVisitedProducts: '商品流量排行',
  pageviews: '访问量',
  product: '商品',
  crossStoreSpendSave: '满减',
  message: '消息',
  popup: {
    readAndAcknowledge: '已阅读并知晓'
  },
  toProcessAftersaleOld: '售后待处理(旧)',
  toProcessAftersaleNew: '售后待处理(新)'
}
